import { useContext, useEffect, useRef, useState } from 'react';
import { DataList } from '../context/Datalist';
import Button_check from './Button_check';
import Getdata from '../functions/getdata';
import setDataLocal from '../functions/setData';
import { Edit_context } from '../context/Edited-context';
export default function Inp({theme,inp_todo}) {
  let listData = useContext(DataList);
  let {etat,id,setEdited} = useContext(Edit_context);
  let [valid,setValid] = useState(false);
  let [Checked,setChecked] = useState(false);
  let start_work = useRef(false);
  useEffect(_ => {
    if(listData.Data.length > 0 && etat) {                                                
        let [item] = listData.Data.filter(ele => ele.id == id);
        if(item.complete){
          setChecked(true);
        }
    }
  },[etat,DataList.Data])
  useEffect(_ => {
    if(valid && etat) {
      let new_list = listData.Data.map(ele => {
        if(ele.id == id) {
          ele.value = inp_todo.current.value;
          if(Checked) {
            ele.complete = true
          }else {
            ele.complete = false;
          }
          return ele;
        }
        return ele;
      });
      setDataLocal(false,new_list);
      inp_todo.current.value = '';
      listData.setData(new_list);
      setValid(false);
      setChecked(false);
      setEdited({etat : false,id : '-1'});
    }
    if(valid && !etat) {
      let item;
      if(listData.Data.length == 0) {
          item = {
            id : 1,
            value : inp_todo.current.value,
            complete : Checked
          }
      }else {
        let id_start = listData.Data[listData.Data.length - 1].id;
        item = {
          id : +id_start + 1,
          value : inp_todo.current.value.trim(),
          complete : Checked
        }
      }
      setDataLocal(item,listData.Data);
      inp_todo.current.value = '';
      listData.setData(Getdata())
      setValid(false);
      setChecked(false);
    }
  },[listData.Data,valid,Checked])
    return (
    <div className={`inp ${theme === 'dark' ? 'dark' : ''}`} onKeyDown={e => {
      if(e.key == 'Enter') {
        if(inp_todo.current.value.trim() !== '') {
          setValid(true);
        }
      }
    }}>
        <Button_check Checked = {Checked} setChecked = {setChecked}/>
        <input type='text' placeholder='Create a new todo...' id='inp_todo' ref={inp_todo}/>
    </div>
  )
}
